import { ReactComponent as Logo } from "../../icons/logo_main.svg";

interface TitleProps {
  strapline?: string;
  title: string;
}

const Title = ({ strapline, title }: TitleProps) => {
  return (
    <div className="mb-4 flex w-full flex-row items-start sm:pr-[70px]">
      <div className="flex h-full flex-col justify-center">
        {strapline && (
          <p className="font-[Roboto] text-lg font-[400] leading-6 text-white drop-shadow-md">
            {strapline}
          </p>
        )}
        <h2 className="font-['Rubik'] text-3xl font-[500] uppercase leading-8 text-period-color drop-shadow-md">
          {title}
        </h2>
      </div>
    </div>
  );
};

export default Title;
